module.exports = __webpack_public_path__ + "img/menu_question-sharp.bd5dd9f6.svg";